// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2LgEy","col":"styles_col__gy00m","actions":"styles_actions__19I6a","conflict":"styles_conflict__35EP5"};